
import { Link } from 'react-router-dom';

const HeroSection = () => {
  const scrollToSection = () => {
    const section = document.getElementById('what-we-look-for');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: 'url(https://static.readdy.ai/image/2a3205e7e8ef8b3d476f9ddb9e8c5218/8f3f8655671d39dae90ebc2cd58860db.png)'
      }}
    >
      {/* Subtle dark overlay to soften the sunset and improve text readability */}
      <div className="absolute inset-0 bg-black/25"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full relative z-10">
        <div className="max-w-3xl flex flex-col" style={{ minHeight: '70vh' }}>
          <div style={{ marginTop: '15vh' }}>
            <h1 className="font-playfair text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Sell your business without selling out your <span className="text-[#C9A227]">legacy</span>
            </h1>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              We create smooth, confidential exits that protect your people, customers, and reputation.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 mt-auto" style={{ marginBottom: '15vh' }}>
            <button 
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="btn-primary text-lg px-8 py-4"
            >
              Schedule a Confidential Call
            </button>
            <button 
              onClick={scrollToSection}
              className="btn-secondary text-lg px-8 py-4 text-center"
            >
              What We Look For
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
